module.exports = __webpack_public_path__ + "img/step04_a_stand_basic_right_front_leg.f8921650.png";